import React from 'react';

interface MarqueeProps {
  items: (string | { src: string; alt: string })[];
}

export const Marquee: React.FC<MarqueeProps> = ({ items }) => {
  return (
    <div className="relative flex overflow-x-hidden border-y border-white/5 bg-black py-6 md:py-8">
      <div className="animate-marquee whitespace-nowrap flex items-center">
        {items.concat(items).map((item, idx) => (
          // Reduced spacing: mx-12 -> mx-6 (mobile), md:mx-32 -> md:mx-16 (desktop)
          <div key={idx} className="mx-6 md:mx-16 flex items-center justify-center">
            {typeof item === 'string' ? (
              <span className="text-xl md:text-3xl font-bold text-zinc-700 hover:text-white transition-colors cursor-default uppercase tracking-tighter font-['Space_Grotesk']">
                {item}
              </span>
            ) : (
              <img 
                src={item.src} 
                alt={item.alt}
                loading="lazy"
                decoding="async"
                // Reduced height: h-12 -> h-8 (mobile), md:h-16 -> md:h-12 (desktop)
                className="h-8 md:h-12 w-auto object-contain max-w-none transition-all duration-500 opacity-50 hover:opacity-100 grayscale hover:grayscale-0"
              />
            )}
          </div>
        ))}
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 80s linear infinite; 
        }
      `}</style>
      
      {/* Adjusted edge fades width to match new proportions */}
      <div className="absolute inset-y-0 left-0 w-20 md:w-60 bg-gradient-to-r from-black via-black/80 to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-20 md:w-60 bg-gradient-to-l from-black via-black/80 to-transparent z-10" />
    </div>
  );
};